import ValueChangeStore from '@src/utils/store/value-change-store';
import { observable } from 'mobx';

import { noop } from '@src/utils/common-util';
import { useEffect, useRef } from 'react';

class InputStore {
  valueStore = new ValueChangeStore({ value: '' });

  maxLength = undefined;
  /**
   * 是否出现异常
   * @type {boolean}
   */
  @observable isError = false;

  @observable validator = noop;
  /**
   * 错误信息提示文案
   * @type {string}
   */
  @observable errorMessage = '';

  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  use() {
    this.inputRef = useRef(null);
    useEffect(
      () => {
        this.isError = false;
      },
      [this.valueStore.value]
    );
  }
}

export default InputStore;
